import image from "../images/tamer-smALL.webp";
import Container from "./Container";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import DruzeIcon from "../images/Druze_star.svg.png";
import { useState, useEffect } from "react";
import { useMenu } from "../contexts/menuContext";
export default function MainPage() {
  const [animitionDir, setAnimitionDir] = useState("normal");
  const [scrollY, setScrollY] = useState("");
  let { menuState, setMenuState } = useMenu();
  // Word Change //
  const words = [
    "<Front end Devel",
    "<Front end Develo",
    "<Front end Develop",
    "<Front end Developer",
    "<Front end Developer/",
    "<Front end Developer/>",
  ];

  let [word, setWord] = useState(words[0]);
  useEffect(() => {
    let index = 0;

    const interval = setInterval(() => {
      setWord(words[index]);
      index = (index + 1) % words.length; // Loops back to 0 after reaching the end
    }, 1000);

    return () => clearInterval(interval); // Cleanup when component unmounts
  }, []);
  // Word Change //
  return (
    <div
      style={{
        width: "100%",
        overflowX: "hidden",
        //  position: "relative"
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          // position: "relative",
          overflow: "hidden",
          height: "calc(100% - 84px)",
        }}
      >
        <div
          className="image-parent"
          style={{
            // bottom: "0",
            // position: "absolute",
            // left: "50%",
            // transform: " translateX(-50%)",
            width: "100%",
            display: "flex",
            height: "100%",
            justifyContent: "center",
            alignItems: "flex-end",
          }}
        >
          <Container>
            {/* Add parallax effect */}
            <img
              className="tamer-image"
              src={image}
              style={{ height: "100vh", width: "auto" }}
            />
          </Container>
        </div>
        <div
          className="main-page-absolute-text"
          style={{
            position: "absolute",
            width: "95%",
            zIndex: "100",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            color: "white",
            top: "50%",
            transform: "translateY(-50%)",
            height: "fit-content",
          }}
        >
          <div
            className="location-info"
            style={{
              backgroundColor: "#1C1D20",
              height: "100px",
              width: "200px",
              color: "white",
              display: "flex",
              alignItems: "center",
              padding: "0 15px",
              borderTopRightRadius: "80px",
              borderBottomRightRadius: "80px",
            }}
          >
            <div
              className="location-text"
              style={{
                width: "200px !important",
                marginRight: "15px",
                fontSize: "14px",
              }}
            >
              <h4 style={{ letterSpacing: "2px" }}>Located In</h4>
              <h4 style={{ letterSpacing: "2px" }}>As-Suwayda</h4>
              {/* <h4 style={{ letterSpacing: "2px" }}>Syria</h4> */}
            </div>
            <span className="location-Icon" style={{ margin: "0" }}>
              {/* <img src={DruzeIcon} style={{ width: "40px" }}></img> */}
              <LanguageOutlinedIcon
                style={{ fontSize: "50px", fontWeight: "200" }}
              />
            </span>
          </div>
          <div
            className="tamers-info"
            style={{ textAlign: "center", lineHeight: "1.6" }}
          >
            <h1 className="specail-word">
              {word}
              <span className="brush-icon"></span>
            </h1>
          </div>
        </div>
        {/* Walking Text */}
        <div
          style={{
            position: "absolute",
            bottom: "10px",
            width: "100%",
            // display: "flex",
            // justifyContent: "center",
            // overflow: "hidden",
            textWrap: "nowrap",
            opacity: "0.9",
            overflow: "hidden",
            animationDirection: animitionDir,
          }}
        >
          <h1
            className="Walking-name"
            style={{
              fontSize: "150px",
              fontWeight: "700",
              color: "white",
              display: "inline-block",
              letterSpacing: "10px",
              animationDirection: animitionDir,
            }}
          >
            TAIM GABER&nbsp;
          </h1>
          <h1
            className="Walking-name"
            style={{
              display: "inline-block",
              fontSize: "150px",
              fontWeight: "700",
              color: "white",
              letterSpacing: "10px",
            }}
          >
            TAIM GABER
          </h1>
        </div>
        {/* Walking Text */}
      </div>
      {/* <TamerMenu /> */}
    </div>
  );
}
